import {animationFeatures, animationIndicators} from "./modules/animation";
import {initSliderTimeline} from "./modules/slider";

animationIndicators();
initSliderTimeline();
animationFeatures();